import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';

/**
 * Route guard.
 *
 * - While AuthProvider is bootstrapping (`isLoading`), render nothing.
 *   The top-level <AuthGate> already paints a full-page spinner — emitting
 *   another one here would double-flash and we'd risk redirecting to
 *   /login before the bootstrap has had a chance to rehydrate the token.
 * - After bootstrap, redirect unauthenticated users to /login.
 * - Optionally enforce a (resource, action) RBAC check.
 */
export default function ProtectedRoute({ children, resource, action }) {
  const { user, isLoading, can } = useAuth();
  const location = useLocation();

  if (isLoading) return null;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (resource && action && !can(resource, action)) {
    return (
      <div className="centered-screen">
        <div className="card">
          <h2>Access denied</h2>
          <p>You don't have permission to view this page.</p>
        </div>
      </div>
    );
  }

  return children;
}
